import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BASE_URL } from "../config";
import Ecosystem from "../components/Ecosystem/Ecosystem";
import HeroShowcase from "./HeroShowcase";
import { HiUserGroup, HiShieldCheck, HiGlobeAlt } from "react-icons/hi";
import "./LandingPage.css";

const LandingPage = () => {
  const [featuredPlayer, setFeaturedPlayer] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const loadFeaturedPlayer = async () => {
      try {
        const response = await fetch(`${BASE_URL}/featured-player/weekly`);

        if (!response.ok) {
          throw new Error("No featured player available");
        }

        const data = await response.json();

        if (isMounted) {
          setFeaturedPlayer(data);
        }
      } catch (error) {
        console.error("Failed to load weekly featured player:", error);

        if (isMounted) {
          setFeaturedPlayer(null);
        }
      }
    };

    loadFeaturedPlayer();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <main className="landing-root">
      {/* ================= NAVBAR + HERO SECTION ================= */}
      <section className="hero-section">
        <header className="landing-navbar">
          <div className="landing-brand">
            <img
              src="/images/VSN-Icon-White-Cropped.png"
              alt="Virtual Scouting Network Logo"
              className="landing-logo"
            />
            <div className="landing-brand-text">
              <span className="landing-brand-line">
                VIRTUAL <span>SCOUTING</span> NETWORK
              </span>
            </div>
          </div>

          <div className="landing-nav-actions">
            <Link to="/login" className="hero-link">
              <button className="hero-btn hero-btn-secondary">Sign In</button>
            </Link>

            <Link to="/register" className="hero-link">
              <button className="hero-btn hero-btn-primary">Sign Up</button>
            </Link>
          </div>
        </header>

        <div className="hero-layout">
          <div className="hero-content">
            <h1 className="hero-title hero-title-main">
              VIRTUAL <span>SCOUTING</span> NETWORK
            </h1>

            <h2 className="hero-subtitle">
              Discover, scout, and sign football talent worldwide.
            </h2>

            <p className="hero-description">
              Built for Scouts, Agents, Clubs, and Players — all in one platform.
            </p>

            {/* ================= TRUST STRIP (UPDATED) ================= */}
            <div className="hero-trust-strip">
              <div className="trust-item">
                <HiUserGroup className="trust-icon" />
                <span>Built for Scouts</span>
              </div>

              <div className="trust-item">
                <HiShieldCheck className="trust-icon" />
                <span>Trusted by Clubs</span>
              </div>

              <div className="trust-item">
                <HiGlobeAlt className="trust-icon" />
                <span>Global Talent Discovery</span>
              </div>
            </div>
          </div>

          <HeroShowcase player={featuredPlayer} />
        </div>

        {/* visual atmosphere */}
        <div className="hero-visual-layer" />
        <div className="hero-glow hero-glow-left" />
        <div className="hero-glow hero-glow-right" />
      </section>

      {/* ================= TRANSITION ================= */}
      <section className="ecosystem-preview">
        <p className="ecosystem-preview-text">
          Trusted infrastructure built for the modern game.
        </p>
      </section>

      {/* ================= ECOSYSTEM SECTION ================= */}
      <Ecosystem />

      {/* ================= FOOTER ================= */}
      <footer className="landing-footer">
        <p>
          Powered by the VSN Ecosystem · Built for football · ©{" "}
          {new Date().getFullYear()} Virtual Scouting Network
        </p>

        <div className="footer-links">
          <a href="/privacy-policy.html">Privacy Policy</a>
          <span> · </span>
          <a href="/terms-of-service.html">Terms of Service</a>
        </div>
      </footer>
    </main>
  );
};

export default LandingPage;



